import { createContext, ReactNode, useCallback, useContext, useEffect, useRef, useState } from "react";
import { ILayoutContext, ILayoutProps } from "./layout.interface";
import { APP_CONFIGS } from "../../constants";
import { TranslationContext } from "../translation/translation.provider";

const layoutInitValues: ILayoutContext = {
    navbar: { current: null },
    header: { current: null },
    main: { current: null },
    handleMenu: Function.prototype(),
    actions: undefined,
    setActions: Function.prototype(),
    title: "",
    setTitle: Function.prototype()
};

export const LayoutContext = createContext<ILayoutContext>(layoutInitValues);

const LayoutProvider = ({ children }: ILayoutProps) => {
    const { translate } = useContext(TranslationContext);
    const navbar = useRef<HTMLElement>(null);
    const header = useRef<HTMLElement>(null);
    const main = useRef<HTMLElement>(null);
    const [actions, setActions] = useState<ReactNode>();
    const [title, setTitle] = useState<string>("");

    useEffect(() => {
        let domTitle = APP_CONFIGS.title;

        if (title) domTitle += " | " + translate(title, title);

        document.title = domTitle;
    }, [title, translate]);

    const handleMenu = useCallback(
        (open?: boolean) => {
            if (open === undefined) navbar.current?.classList.toggle("is_active");
            else if (open) navbar.current?.classList.add("is_active");
            else navbar.current?.classList.remove("is_active");

            const isOpen = navbar.current?.classList.contains("is_active");
            if (isOpen) document.body.classList.add("overflow-hidden");
            else document.body.classList.remove("overflow-hidden");
        },
        [navbar]
    );

    return (
        <LayoutContext.Provider value={{ navbar, header, main, handleMenu, actions, setActions, title, setTitle }}>
            {children}
        </LayoutContext.Provider>
    );
};

export default LayoutProvider;
